import { createFileRoute } from "@tanstack/react-router";
import { CancellationRequestsPage } from "@/components/admin/cancellation-requests/CancellationRequestsPage";

export const Route = createFileRoute("/dashboard/admin/cancellation-requests")({
  component: CancellationRequestsPage,
});
